import Pagination from 'rc-pagination/lib/locale/fr_FR';
import DatePicker from '../date-picker/locale/fr_FR';
import TimePicker from '../time-picker/locale/fr_FR';
import Calendar from '../calendar/locale/fr_FR';
const localeValues = {
    locale: 'fr',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    Table: {
        filterTitle: 'Filtrer',
        filterConfirm: 'OK',
        filterReset: 'Réinitialiser',
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Annuler',
        justOkText: 'OK',
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Annuler',
    },
    Transfer: {
        searchPlaceholder: 'Recherche',
        itemUnit: 'élément',
        itemsUnit: 'éléments',
    },
    Empty: {
        description: 'Aucune donnée',
    },
    Upload: {
        uploading: 'Téléchargement...',
        removeFile: 'Effacer le fichier',
        uploadError: 'Erreur de téléchargement',
        previewFile: 'Fichier de prévisualisation',
        downloadFile: 'Télécharger un fichier',
    },
    Text: {
        edit: 'éditer',
        copy: 'copier',
        copied: 'copie effectuée',
        expand: 'développer',
    },
};
export default localeValues;
